import React from 'react';
import { useHistory } from "react-router-dom";
import { propsToJS } from '__utils/immutable-to-js';
import { useSelector, useDispatch } from 'react-redux';
import { SuccessBtnWhiteGreenBorder, SuccessButton } from 'components/button';
import ConfirmationModal from 'components/confirmation-modal';
import './index.css';
import PendingOrderSelector from './pendingOrder.selector';
import { hideOrderPopupAction } from './pendingOrder.actions';
import { getDefaultHeaders, post } from '__utils/ajax-wrapper';
import { ENDPOINTS } from 'constants/endpoints';
import { AjaxError, AjaxResponse } from 'rxjs/ajax';
import useFlashToggler from '../../hooks/use-flash-toggler';
import { getEventName, Mixpanel } from '__utils/mixpanel';
import CartSelector from 'views/cart/cart.selector';
import UserSelector from 'views/user/user.selector';
import { fetchCustomerOrderDetailsSuccess } from 'views/user/user.actions';

const PendingOrderPopup: React.FC = () => {
    const history = useHistory();
    const flash = useFlashToggler();
    const dispatch = useDispatch();
    const { showPendingOrderPopup, } = propsToJS(useSelector(PendingOrderSelector));
    const { cartDetails } = propsToJS(useSelector(CartSelector));
    const { paymentUrl } = propsToJS(useSelector(UserSelector));


    const discardActiveOrders = () => {
        post(ENDPOINTS.POST_DISCARD_ACTIVE_ORDERS, null, getDefaultHeaders(), true)
            .subscribe((response: AjaxResponse | AjaxError) => {
                const result = response.response;
                if (response.response.data) {
                    dispatch(fetchCustomerOrderDetailsSuccess(''));  
                    Mixpanel.track(getEventName("discardOrders", "clicked", "explore"));
                    dispatch(hideOrderPopupAction());
                }
            }, (error: AjaxError) => {
                flash.error("Something went wrong. Please try again later")
            });
    }

    const continueExistingOrder = () => {
        dispatch(hideOrderPopupAction());
        if (cartDetails && cartDetails?.noOfItems) {
            discardActiveOrders();
        }
        Mixpanel.track(getEventName("continueExistingOrder", "clicked", "explore"));
        history.push('/order-summary?paymentUrl=' + paymentUrl);
    }


    const ModalContent = () => {
        return (
            <div className="successPop">
                <p>You have an existing order in process. You cannot add to/edit the order.</p>
                <p><b>Do you want to cancel the order?</b></p>

                <SuccessBtnWhiteGreenBorder onClick={() => discardActiveOrders()} width="100%">Cancel Order </SuccessBtnWhiteGreenBorder>
                <SuccessButton onClick={() => continueExistingOrder()}>Continue with Existing Order</SuccessButton>
            </div>
        );
    }

    return (
        <div id="pendingOrderPopupDiv">
            {showPendingOrderPopup && <ConfirmationModal
                title="Hold on!"
                customHeader
                modalBody={<ModalContent />}
                closable
                onCancel={() => dispatch(hideOrderPopupAction())}
            >
            </ConfirmationModal>}
        </div>
    );
};

export default PendingOrderPopup;